import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { CountryManagmentService } from 'src/app/core/countries-managment/country-managment.service';
import { RestService } from 'src/app/core/services/rest.service';
import { RawUser } from '../users/users';
import { TranslateService } from '@ngx-translate/core';

export interface DataSetItem {
  label: string;
  value: number;
  color: string;
}
@Injectable({
  providedIn: 'root',
})
export class CompanyListService {
  constructor(
    private restService: RestService,
    private translate: TranslateService
  ) { }

  getCompaniesList(index, size, search, users, active, verified, orderBy, asc) {
    return this.restService
      .get_api_by_params('companies/list', this.createParams(index, size, search, users, active, verified, orderBy, asc))
      .pipe(
        map((res) => {
          return {
            total: res.total,
            result: res.result?.map((company) => {
              let companyType = (company.foreign_company_type) ? company.foreign_company_type : company.company_types?.name;
              return {
                id: company.id,
                type_id: company.type_id,
                country_id: company.country_id,
                country_name: this.translate.instant(`COUNTRIES.ID${company.country_id}`),
                following: company.following,
                name: company.name,
                company_type_name: companyType,
                company_name:
                  company.name +
                  ' ' +
                  (company.type_id === 14 || company.type_id === 18 || company.type_id === 19 || company.type_id === 20 ? '' : companyType),
                modification_date:
                  company.modification_date === '0001-01-01T00:00:00'
                    ? ''
                    : company.modification_date,
                validation_date:
                  company.validation_date === '0001-01-01T00:00:00'
                    ? ''
                    : company.validation_date,
                address: company.location?.name,
                jurisdictionName:
                  company.country_id === 11
                    ? company.foreign_company_type
                      ? company.head_country?.name
                      : company.jurisdiction?.name
                    : company.province?.name,
                active: company.active,
                inactive: !company.active,
              };
            }),
          };
        })
      );
  }

  createParams(index, size, search, users, active?, verified?, orderBy?, asc?) {
    if (orderBy != -1 && asc !== -1) {
      return {
        start: (index - 1) * size,
        limit: size,
        filter: search,
        users_id: users,
        active: active,
        verified: verified,
        order_by_name: orderBy,
        asc: asc
      };
    }
    else {
      return {
        start: (index - 1) * size,
        limit: size,
        filter: search,
        users_id: users,
        active: active,
        verified: verified
      };
    }
  }

  updateFavorite(companyId: number) {
    return this.restService.post_api(`companies/followers/${companyId}`, null);
  }

  deleteCompany(companyId: number) {
    return this.restService.delete_api(
      `companies/delete/force?id=${companyId}`
    );
  }

  statusCompany(companyId: number, active: boolean) {
    return this.restService.put_api(
      `companies/delete/logical-erase/${active}?id=${companyId}`,
      null
    );
  }

  getUsersList() {
    return this.restService.get_api(`users/top/2500/false`).pipe(
      map((res) => {
        if (res.success) {
          return res.result.map((user: RawUser) => {
            return {
              id: user.id,
              fullname: `${user.name} ${user.last_name}`,
              email: user.email
            };
          });
        } else {
          return [];
        }
      })
    );
  }

  getCompaniesStatistics() {
    return this.restService.get_api(`statistics/list`).pipe(
      map((res) => {
        if (res.success) {
          const result = res.result;
          const colors = ['#e17681', '#f4bc53', '#fff3b0', '#8ed580'];
          let totalEXP = result.expirations.reduce(
            (accumulator, currentValue) => accumulator + currentValue.value,
            0
          );

          return {
            companiesDataset: [
              {
                label: 'STATS.VERIFIRED',
                value: result.societies_verified,
                color: '#8ed580',
                total:
                  result.societies_verified + result.societies_non_verified,
              },
              {
                label: 'STATS.NOT_VERIFIRED',
                value: result.societies_non_verified,
                color: '#dee0e4',
                total:
                  result.societies_verified + result.societies_non_verified,
              },
            ],
            expirationsDataset: result.expirations.map((exp, index) => {
              return {
                label: 'STATS.EXP_' + exp.id,
                value: exp.value,
                color: colors[index],
                total: totalEXP,
              };
            }),
            personsDataset: [
              {
                label: 'STATS.IND',
                value: result.persons_individuals,
                color: '#197df83b',
                total:
                  result.persons_legal_entities + result.persons_individuals,
              },
              {
                label: 'STATS.LEGAL',
                value: result.persons_legal_entities,
                color: '#63a9ff',
                total:
                  result.persons_legal_entities + result.persons_individuals,
              },
            ],
            cardItems: [
              {
                label: 'STATS.UP_SHAREHOLDERS',
                value: result.shareholder,
                icon: 'diversity_3',
              },
              {
                label: 'STATS.UP_POWERS',
                value: result.powers,
                icon: 'description',
              },
              {
                label: 'STATS.UP_AUTH',
                value: result.authorities,
                icon: 'groups',
              },
            ],
          };
        } else {
          return {
            companiesDataset: [],
            expirationsDataset: [],
            personsDataset: [],
          };
        }
      })
    );
  }
}
